<app-language-switch></app-language-switch>

<app-eaiws-base-layout *ngIf="!showFormular" [optionsInput]="options"></app-eaiws-base-layout>

<div *ngIf="showFormular" class="formular">
    <app-form-kloeber [options]="options"></app-form-kloeber>
</div>